"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlQueryParam = void 0;
const getUrlQueryParam = name => {
  if (typeof window === 'undefined') {
    return null;
  }
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(name);
};
exports.getUrlQueryParam = getUrlQueryParam;
